/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const teamRoleSchema = z.object({
  createdAt: z.iso.datetime(),
  createdBy: z.string(),
  critical: z.boolean(),
  default: z.boolean(),
  id: z.int(),
  instanceId: z.string().nullish(),
  lastSyncedAt: z.iso.datetime().nullish(),
  name: z.string(),
  organizationId: z.string(),
  sourceId: z.string().nullish(),
  updatedAt: z.iso.datetime(),
  updatedBy: z.string(),
});
